import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Input } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import ContentHeader from "../../../components/shared/ContentHeader";
import PosterTable from "./Table";
import AddEditModal from "./AddEditModal";
import { useTenantPoster } from "../../../hooks/useTenantPoster";
import { StyledPoster } from "./styles";

const Poster = () => {
  const [selectedPoster, setSelectedPoster] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const { posters, loading } = useTenantPoster();

  const showModal = useCallback((data = null) => {
    //@ts-ignore
    setSelectedPoster(data || {});
  }, []);

  const handleCancel = useCallback(() => {
    setSelectedPoster(null);
  }, []);

  useEffect(() => {
    if (posters?.length && selectedPoster?.id) {
      const index = posters?.findIndex(({ id }) => id === selectedPoster?.id);
      if (index !== -1) setSelectedPoster(posters[index]);
    }
  }, [posters]);

  const filteredPosters = useMemo(() => {
    if (!searchTerm) return posters || [];

    const search = searchTerm.toLowerCase();

    return (posters || []).filter((poster) => {
      if (poster?.type === "photo" || poster?.type === "video") return false;
      return poster?.content?.toLowerCase()?.includes(search);
    });
  }, [searchTerm, posters]);

  return (
    <StyledPoster>
      <ContentHeader title={"Posters"}>
        <Input
          placeholder="Search..."
          prefix={<SearchOutlined />}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Button
          type="primary"
          className="add-btn"
          icon={<PlusOutlined />}
          onClick={() => showModal()}
        />
      </ContentHeader>
      <PosterTable
        posters={filteredPosters}
        showModal={showModal}
        loading={loading}
      />
      {selectedPoster && (
        <AddEditModal
          selectedPoster={selectedPoster}
          handleCancel={handleCancel}
        />
      )}
    </StyledPoster>
  );
};

export default Poster;
